<template>
  <div>
    <Transition name="fade" appear>
      <div
        class="modal-overlay-picture"
        v-if="showImage"
        @click="$emit('closeImg')"
      ></div>
    </Transition>
    <Transition name="pop" appear>
      <div class="modal-picture" role="dialog" v-if="showImage">
        <v-icon
          @click="$emit('closeImg')"
          class="icon-1"
          large
          color="white darken-2"
        >
          mdi-close-outline
        </v-icon>

        <!-- <img class="image" src="./fast-electrical-air-nwse26.gif" alt="Sponsored"/> -->
        <img
          lazy-loading
          class="image"
          :src="'https://bluebusinessguide.com.au/' + file_name"
          alt="Sponsored Listings"
        />
        <!-- <v-btn
        class="ma-2 icon-2"
        color="indigo"
        dark
        @click="downloadImg()"
      >Download
        <v-icon
        >
          mdi-download-circle-outline 
        </v-icon></v-btn> -->
      </div>
    </Transition>
  </div>
</template>
<script>
import { axios } from '../../../../utils'

export default {
  props: ['closeImg', 'showImage', 'item'],
  data() {
    return {
      file_name: {}
    }
  },
  mounted() {
    axios.get(`api/admin/contracts/${this.item.id}`).then(res => {
      this.file_name = res.data.image
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.modal-overlay-picture {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  background: #000000;
  opacity: 0.8;
  max-width: 100vw;
}
.modal-picture {
  position: absolute;
  position: fixed;
  top: -8rem;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  // max-width: 60%;
  background: #fff;
  z-index: 9999;
  transform: none;
  background: none;
}

.icon-1 {
  float: right;
  cursor: pointer;
  color: whitesmoke;
}

.icon-2 {
  display: block;
  cursor: pointer;
  color: whitesmoke;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}
</style>
